import { render, staticRenderFns } from "./profileData.vue?vue&type=template&id=05317801&scoped=true&"
import script from "./profileData.vue?vue&type=script&lang=js&"
export * from "./profileData.vue?vue&type=script&lang=js&"
import style0 from "./profileData.vue?vue&type=style&index=0&id=05317801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05317801",
  null
  
)

export default component.exports